import { ref, InjectionKey } from 'vue';
import { defineStore } from 'pinia';
import { ContactChannel } from '@/types/mfa';

export const useMultiFactorAuthStore = defineStore('multiFactorAuthStore', () => {
    // ? STATE
    const selectedContactChannel = ref<ContactChannel | null>(null);
    const multifactorAuthToken = ref<string>('');

    // ? ACTIONS / SETTERS
    function setSelectedContactChannel(contactChannel: ContactChannel | null) {
        selectedContactChannel.value = contactChannel ?? null;
    }

    function setMultifactorAuthToken(token: string) {
        multifactorAuthToken.value = token;
    }

    function reset() {
        selectedContactChannel.value = null;
    }

    return {
        //getter
        selectedContactChannel,
        multifactorAuthToken,
        //setter
        setSelectedContactChannel,
        setMultifactorAuthToken,
        reset,
    };
});

export const multiFactorAuthStoreKey: InjectionKey<() => MultiFactorAuthStore> = Symbol('multiFactorAuthStore');
export type MultiFactorAuthStore = ReturnType<typeof useMultiFactorAuthStore>;
